export default __webpack_public_path__ + "static/media/scas.83912e44.png";